import { TechnicalSpecificationsSectionsState } from 'src/app/+grid-application-shared/entities/sections-state/technicalSpecificationsSectionsState';

export class GridCompTechnicalSpecificationsSectionsState extends TechnicalSpecificationsSectionsState {
  constructor(state?: any) {
    super(state);
  }
}
